import { classColor, isClassId, type ClassId } from "@eldrun/content";
import { gameColor } from "../../render/style/roles.ts";
import { applyTheme } from "../kit/kit-model.ts";
import { readPref, writePref } from "../kit/storage.ts";

/**
 * O acento da UI pela classe (F85, ADR 0017): a única entrada do tema. A tela de escolha, o lobby, a
 * partida e o boot passam por aqui; os componentes só leem `--acento` e `--acento-claro`.
 *
 * A classe escolhida fica lembrada no navegador (`eldrun:classe`) e o acento vale em toda parte, menu
 * inclusive; quem nunca escolheu vê o tema neutro.
 */

type Themed = Parameters<typeof applyTheme>[0];

/** A última classe escolhida neste navegador (sem escolha, `undefined`). */
export function rememberedClass(): ClassId | undefined {
  const saved = readPref("classe", "");
  return isClassId(saved) ? saved : undefined;
}

/** A cor do acento da classe `id` no modo em uso (o daltônico troca pela variante). */
export function classAccent(id: ClassId): string {
  return gameColor(classColor(id));
}

/** Aplica o acento da classe `id` (sem classe, o neutro) e devolve a cor aplicada. */
export function applyClassTheme(id: ClassId | undefined, target: Themed = document.body): string | undefined {
  const accent = id ? classAccent(id) : undefined;
  applyTheme(target, accent);
  return accent;
}

/** Escolheu a classe `id`: lembra no navegador e acende o acento dela. */
export function chooseClassTheme(id: ClassId, target: Themed = document.body): string {
  writePref("classe", id);
  return applyClassTheme(id, target)!;
}
